"use client";

import { c as _c } from "react/compiler-runtime";
import { HiArrowTopRightOnSquare } from "react-icons/hi2";
import { RiCapsuleLine } from "react-icons/ri";
import { useUser } from "@/contexts/user-provider";
import { useLaunchDoseSpot } from "@/hooks/use-launch-dosespot";
import { cx } from "@/lib/tailwind-utils";
import { useDosespotNotificationCounts } from "@/query/dosespot/dosespot-notifications";
export function EprescribingBanner() {
  const $ = _c(13);
  const {
    currentUser
  } = useUser();
  const {
    data: dosespotCounts
  } = useDosespotNotificationCounts();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      openInNewTab: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    launchDoseSpot
  } = useLaunchDoseSpot(t0);
  const totalPending = dosespotCounts?.totalPending ?? 0;
  if (!currentUser?.dosespotUserId) {
    return null;
  }
  let t1;
  if ($[1] !== launchDoseSpot) {
    t1 = () => launchDoseSpot();
    $[1] = launchDoseSpot;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = totalPending > 0 ? "bg-status-warning-bg text-status-warning-text" : "bg-background-secondary text-foreground-secondary";
  let t3;
  if ($[3] !== t2) {
    t3 = cx("flex w-full items-center gap-2 border-b border-border px-4 py-2.5 text-left text-body transition-colors hover:opacity-80", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <RiCapsuleLine className="h-4 w-4 shrink-0" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = totalPending > 0 ? `${totalPending} pending e-prescribing ${totalPending === 1 ? "notification" : "notifications"}` : "Open e-prescribing";
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="flex-1 font-medium">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HiArrowTopRightOnSquare className="h-3.5 w-3.5 shrink-0" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t6) {
    t8 = <button onClick={t1} className={t3}>{t4}{t6}{t7}</button>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}